// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1BQ8c","container":"styles_container__2NUm3","title":"styles_title__3ZB8u","wrapper":"styles_wrapper__3q32H","answer":"styles_answer__2ITww"};